import React from 'react'
import { useDispatch } from 'react-redux'

import { deleteCandidates } from 'ducks/concurrency'
import { useCandidateGroupData, useModal, useSnackbar } from 'hooks'

const useDeleteCandidateGroupModalMutations = () => {
  const dispatch = useDispatch()

  const handleDeleteCandidates = React.useCallback(
    ({ projectId, status }, { onShowSnackbar }) => {
      dispatch(deleteCandidates({ projectId, status }, { onShowSnackbar }))
    },
    [dispatch],
  )

  return {
    handleDeleteCandidates,
  }
}

export const useDeleteCandidateGroupModalState = () => {
  const {
    state: { candidates, count, pks },
  } = useCandidateGroupData()

  return {
    state: {
      candidates,
      count,
      pks,
    },
  }
}

export const useDeleteCandidateGroupModal = state => {
  const { projectId, status } = state

  const { isOpen, handleClose, handleOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleDeleteCandidates } = useDeleteCandidateGroupModalMutations()

  const handleConfirm = React.useCallback(() => {
    handleDeleteCandidates(
      { projectId, status },
      { onShowSnackbar: handleShowSnackbar },
    )
    handleClose()
  }, [
    projectId,
    status,
    handleClose,
    handleDeleteCandidates,
    handleShowSnackbar,
  ])

  return {
    handleDeleteCandidateGroupModalClose: handleClose,
    handleDeleteCandidateGroupModalConfirm: handleConfirm,
    handleDeleteCandidateGroupModalOpen: handleOpen,
    isDeleteCandidateGroupModalOpen: isOpen,
  }
}
